export enum RfChannelActivity {
	Overload = 'OVERLOAD',
	Good = 'GOOD',
	Adequate = 'ADEQUATE',
	Poor = 'POOR',
	None = 'NONE'
}
